module.exports = __webpack_public_path__ + "img/boyler.706be5a9.svg";